import { Fragment } from 'react';

import { FilterListItem } from '@components/filter-list-item';
import { AnimatedRadio } from '@components/radio-group/animated-radio';
import { useScopedTranslate } from '@locale/translate';

import type { MenuProps } from './types';

import { FilterComparer } from '../common';
import { useIsExternalFilterMode } from '../external-filter-mode-context';
import { FilterSubheading } from '../subheading';

export const EMPTY_COMPARERS: Array<FilterComparer> = ['is_empty', 'is_not_empty'];

export const AnyValueGroup = ({ state, actions }: Pick<MenuProps, 'state' | 'actions'>) => {
  const { t } = useScopedTranslate(locale);
  const isExternalFilterMode = useIsExternalFilterMode();

  if (isExternalFilterMode) {
    return null;
  }

  return (
    <Fragment>
      <FilterSubheading text={t('anyValue')} />
      {EMPTY_COMPARERS.map((comparer) => {
        return (
          <FilterListItem
            key={comparer}
            icon={<AnimatedRadio checked={state.comparer === comparer} />}
            label={t(`core.comparator.${comparer}`)}
            onClick={() => {
              actions.applyFilter({ comparer, value: '' });
            }}
          />
        );
      })}
    </Fragment>
  );
};

const locale = {
  en: {
    anyValue: 'Value',
  },
  is: {
    anyValue: 'Gildi',
  },
};
